"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.System = void 0;
const effect_1 = require("effect");
const NAMESPACE = 'Unit.Common';
exports.System = effect_1.Schema.Literal('SI', 'IMPERIAL', 'US').annotations({
    identifier: `${NAMESPACE}.System`,
    description: `\
SI: https://en.wikipedia.org/wiki/International_System_of_Units \
IMPERIAL: https://en.wikipedia.org/wiki/Imperial_units \
US: https://en.wikipedia.org/wiki/United_States_customary_units \
`,
    pretty: () => system => ({
        SI: 'International System of Units',
        IMPERIAL: 'Imperial units',
        US: 'United States customary units',
    })[system],
});
//# sourceMappingURL=common.js.map